import React from 'react';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import { withStyles } from '@material-ui/core';

const styles = theme => ({
  error: {
    color: theme.palette.error.dark
  }
});

class RenderTextField extends React.Component { 
  render () {
    const { input, label, options, meta: { touched, error }, classes, onChange, ...custom } = this.props;

    return (
      <React.Fragment>
        <TextField
          label={label}
          {...input}
          {...custom}
        />

        {error && touched && <FormHelperText className={classes.error}>{error}</FormHelperText>}
      </React.Fragment>
    )
  }
}

export default withStyles(styles)(RenderTextField);